import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=3429a711&scoped=true&"
import script from "./PopupModal.vue?vue&type=script&lang=js&"
export * from "./PopupModal.vue?vue&type=script&lang=js&"
import style0 from "./PopupModal.vue?vue&type=style&index=0&id=3429a711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429a711",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3429a711')) {
      api.createRecord('3429a711', component.options)
    } else {
      api.reload('3429a711', component.options)
    }
    module.hot.accept("./PopupModal.vue?vue&type=template&id=3429a711&scoped=true&", function () {
      api.rerender('3429a711', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PopupModal.vue"
export default component.exports